
import SearchPluginContainer from './SearchPluginContainer.vue';


const SearchPlugin = {
  install(Vue, router) {
		 if (this.installed) {
      return
    }
    this.installed = true
    this.event = new Vue()
		this.searchContainerInstance = null;
		
     const searchContainer = new Vue({
	    						router,
									render: createElement => createElement(SearchPluginContainer)
							})
			searchContainer.$mount(document.body.appendChild(document.createElement('div')));
	    
      searchContainer.$on('termupdated',function(args){
          SearchPlugin.event.$emit('updateterm',args);
        })

       searchContainer.$on('showView',function(args){
          SearchPlugin.event.$emit('showView',args);
        })
      
        Vue.prototype.$search = {
            searchNow (params) {
                if(!params){
                  params={term:null};
                }
                SearchPlugin.event.$emit('searchNow', params);
              },
            toggleSearch(){
                SearchPlugin.event.$emit('toggleSearch');
              }
        }
	
  }
}

export default SearchPlugin




// WEBPACK FOOTER //
// ./src/plugins/SearchPlugin/index.js